import chroma from 'chroma-js'
import { black, gray, overlays } from './colors'

export type DossDepth = {
  0: string
  1: string
  2: string
  3: string
  4: string
  5: string
  6: string
}

/**
 * Inner and outer shadows for components, methodology drawn from Radix CSS primitives.
 * https://www.radix-ui.com/themes/docs/theme/shadows
 *
 * See latest version here of their shadow tokens css here:
 * https://github.com/radix-ui/themes/blob/main/packages/radix-ui-themes/src/styles/tokens/shadow.css
 *
 * This approach utilizes and innner and outer shadows to create a subtle realistic depth effect.
 */
export const depth: DossDepth = {
  0: `inset 0 0 0 1px ${chroma(gray[5]).alpha(0.5).css()}, inset 0 1.5px 2px 0 ${chroma(gray[2])
    .alpha(0.2)
    .css()}, inset 0 1.5px 2px 0 ${chroma(black).alpha(0.2).css()}`,
  1: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 0 0 0.5px ${chroma(black)
    .alpha(0.1)
    .css()}, 0 1px 1px 0 ${chroma(gray[4]).alpha(0.4).css()}, 0 2px 1px -1px ${chroma(black)
    .alpha(0.1)
    .css()}, 0 1px 3px 0 ${chroma(black).alpha(0.1).css()}`,
  2: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 0 0 0.5px ${chroma(black)
    .alpha(0.1)
    .css()}, 0 1px 1px 0 ${chroma(gray[4]).alpha(0.4).css()}, 0 2px 1px -1px ${chroma(black)
    .alpha(0.1)
    .css()}, 0 1px 3px 0 ${chroma(black).alpha(0.1).css()}`,
  3: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 2px 3px -2px ${chroma(gray[3])
    .alpha(0.3)
    .css()}, 0 3px 12px -4px ${chroma(black).alpha(0.2).css()}, 0 4px 16px -8px ${chroma(black)
    .alpha(0.2)
    .css()}`,
  4: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 8px 40px ${chroma(black)
    .alpha(0.1)
    .css()}, 0 12px 32px -16px ${chroma(gray[3]).alpha(0.3).css()}`,
  5: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 12px 60px ${chroma(black)
    .alpha(0.3)
    .css()}, 0 12px 32px -16px ${chroma(gray[5]).alpha(0.5).css()}`,
  6: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()}, 0 12px 60px ${chroma(black)
    .alpha(0.3)
    .css()}, 0 16px 64px ${chroma(gray[2]).alpha(0.2).css()}, 0 16px 36px -20px ${chroma(gray[7])
    .alpha(0.7)
    .css()}`,
}

export type DossCardShadow = {
  normal: string
  hover: string
  active: string
}

export const cardShadow: DossCardShadow = {
  normal: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()},
            0 1px 1px 0 ${chroma(gray[4]).alpha(0.4).css()},
            0 2px 1px -1px ${chroma(black).alpha(0.1).css()},
            0 1px 3px 0 ${chroma(black).alpha(0.1).css()}`,
  hover: `0 0 0 1px ${chroma(gray[3]).alpha(0.3).css()},
           0 0 0 0 ${chroma(overlays[1]).css()},
           0 0 0 0.5px ${chroma(black).alpha(0.1).css()},
           0 1px 1px 0 ${chroma(gray[4]).alpha(0.4).css()},
           0 2px 1px -1px ${chroma(black).alpha(0.1).css()},
           0 1px 3px 0 ${chroma(black).alpha(0.1).css()}`,

  active: `0 0 0 1px ${chroma(gray[3]).alpha(0.5).css()},
           0 0 0 0 ${chroma(overlays[3]).css()},
           0 0 0 0.5px ${chroma(black).alpha(0.3).css()},
           0 1px 1px 0 ${chroma(gray[4]).alpha(0.4).css()},
           0 2px 1px -1px ${chroma(black).alpha(0.3).css()},
           0 1px 3px 0 ${chroma(black).alpha(0.3).css()}`,
}
